// extracted by mini-css-extract-plugin
export default {"overlay":"FC-z","bodyOpen":"GC-z","content":"HC-z","header":"IC-z","close":"JC-z","closeNoHeading":"KC-z"};